exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display[data-v-197d1554]{text-align:center;padding:0 1rem;font-size:1rem}.display button[data-v-197d1554]{width:175px}@media screen and (min-width: 1920px){.display button[data-v-197d1554]{width:100%}}.display .display__info[data-v-197d1554]{font-size:.7rem}", ""]);

// exports
